export default __webpack_public_path__ + "static/circular-0a3bd0cebcb0aeaf341fabef9bfc5915.gif";